import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientSetting } from "../typeDefs/configuration";

export interface ConfigurationState {
	clientSettings: ClientSetting[];
	loading: boolean;
}

const initialState: ConfigurationState = {
	clientSettings: [],
	loading: false,
};

export const clientSettingsSlice = createSlice({
	name: "clientSettings",
	initialState,
	reducers: {
		setClientSettings: (state, action: PayloadAction<ClientSetting[]>) => {
			state.clientSettings = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
	},
});

export const { setClientSettings, setLoading } = clientSettingsSlice.actions;

export default clientSettingsSlice.reducer;
